import React, { useEffect, useState } from 'react';
import _ from 'lodash';
import { v4 as uuidv4 } from 'uuid';
import { FormHelperText } from '@mui/material';
import useTranslation from 'Hooks/useTranslation';
import Answer from '../../../Answer';

function MultipleChoice({ question, questions, formData, setFormData, setUnchanged, positionQuestion }) {
  const { t2 } = useTranslation('EditCourse');
  const [answerOptions, setAnswerOptions] = useState();

  const generateAnswers = questionData => {
    const answers = questionData?.answers;

    if (answers.length > 0) {
      if (answers?.[(answers?.length || 0) - 1].response === '') {
        setAnswerOptions(answers);
        return;
      }
    }

    if (answers.length < 10) {
      setAnswerOptions([
        ...answers,
        {
          id: `${questionData.id}-answer_${uuidv4()}`,
          order: answers.length + 1,
          isCorrect: false,
          response: '',
        },
      ]);

      return;
    }

    setAnswerOptions(answers);
  };

  useEffect(() => {
    generateAnswers(question);
  }, [question]);

  useEffect(() => {
    if (answerOptions?.length > 0) {
      const isCorrectArray = answerOptions.map(answer => answer.isCorrect);
      if (!isCorrectArray.includes(true)) {
        setFormData({
          ...formData,
          errors: {
            ...formData.errors,
            [`question-${question.id}_isCorrect`]: t2('FormErrorEvaluationIsCorrect'),
          },
        });
      } else if (formData.errors[`question-${question.id}_isCorrect`] !== undefined) {
        const formDataCopy = _.cloneDeep(formData);
        delete formDataCopy.errors[`question-${question.id}_isCorrect`];
        setFormData({ ...formDataCopy });
      }
    }
  }, [question]);

  const isCorrectHandler = optionIndex => {
    const answerOptionsCopy = _.cloneDeep(answerOptions);

    const mappedAnswers = answerOptionsCopy.map((answer, index) => {
      if (optionIndex !== index) {
        answer.isCorrect = false;
      } else {
        answer.isCorrect = true;
      }

      return answer;
    });

    const formDataCopy = _.cloneDeep(formData);
    formDataCopy.questions[positionQuestion].answers = mappedAnswers;
    setFormData(formDataCopy);
  };

  return (
    <div>
      {answerOptions?.length > 0 &&
        answerOptions.map((answer, index) => (
          <Answer
            key={answer.id}
            position={index}
            positionQuestion={positionQuestion}
            answer={answer}
            answerOptions={answerOptions}
            setAnswerOptions={setAnswerOptions}
            question={question}
            questions={questions}
            isCorrectHandler={isCorrectHandler}
            formData={formData}
            setFormData={setFormData}
            isLastItem={index === answerOptions.length - 1}
            setUnchanged={setUnchanged}
          />
        ))}
      {formData?.errors[`question-${question.id}_isCorrect`] && (
        <FormHelperText sx={{ color: 'red' }}>{formData.errors[`question-${question.id}_isCorrect`]}</FormHelperText>
      )}
      {formData?.errors[`question-${question.id}_atLeastTwoAnswers`] && (
        <FormHelperText sx={{ color: 'red' }}>
          {formData.errors[`question-${question.id}_atLeastTwoAnswers`]}
        </FormHelperText>
      )}
    </div>
  );
}

export default MultipleChoice;
